import { render, staticRenderFns } from "./campaign-list.vue?vue&type=template&id=2d9ff180&scoped=true"
import script from "./campaign-list.vue?vue&type=script&lang=js"
export * from "./campaign-list.vue?vue&type=script&lang=js"
import style0 from "./campaign-list.vue?vue&type=style&index=0&id=2d9ff180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9ff180",
  null
  
)

export default component.exports